export default __webpack_public_path__ + "static/media/b4.1174ca86.jpg";